import { buffers, END, eventChannel } from 'redux-saga';
import { authAliasSelector, authTokenSelector } from 'selectors/authSelectors';
import { store } from 'MooTeam';
import { aliasHeader } from 'util/config';

export const createFileUploadChannel = (endpoint, file, params) => {
  return eventChannel((emitter) => {
    const xhr = new XMLHttpRequest();

    const onProgress = (e) => {
      if (e.lengthComputable) {
        const progress = e.loaded / e.total;
        emitter({ progress });
      }
    };
    const onFailure = (response) => {
      let data = null;
      if (response) {
        try {
          data = JSON.parse(response);
        } catch (error) {
          // skip handling and just throw error
        }
      }

      emitter({ err: new Error('Upload failed'), errData: data });
      emitter(END);
    };

    xhr.upload.addEventListener('progress', onProgress);
    xhr.upload.addEventListener('error', onFailure);
    xhr.upload.addEventListener('abort', onFailure);

    xhr.onreadystatechange = () => {
      const { readyState, status, response } = xhr;
      if (readyState === 4) {
        if (status === 200) {
          emitter({ success: true, response });
          emitter(END);
        } else {
          onFailure(response);
        }
      }
    };

    const token = authTokenSelector(store.getState());
    const alias = authAliasSelector(store.getState());

    xhr.open('POST', endpoint, true);
    xhr.setRequestHeader('Authorization', 'Bearer ' + token);
    xhr.setRequestHeader(aliasHeader, alias);

    const data = new FormData();
    data.append('uploadedFile', file);
    const { entity, entityId, withoutEntity } = params;
    if (entity && entityId) {
      data.append('entity', entity);
      data.append('entityId', entityId);
    }

    if (withoutEntity) {
      data.append('withoutEntity', withoutEntity);
    }

    xhr.send(data);

    return () => {
      xhr.upload.removeEventListener('progress', onProgress);
      xhr.upload.removeEventListener('error', onFailure);
      xhr.upload.removeEventListener('abort', onFailure);
      xhr.onreadystatechange = null;
      xhr.abort();
    };
  }, buffers.sliding(2));
};
